import React from 'react';
import { Box, Rating, Typography } from '@mui/material';
import { RATING_CATEGORIES } from '../types';

type RatingCategoriesFormProps = {
  colleagueFirstName: string;
  ratings: Record<string, number>;
  onRatingChange: (key: string, value: number | null) => void;
};

export const RatingCategoriesForm: React.FC<RatingCategoriesFormProps> = ({
  colleagueFirstName,
  ratings,
  onRatingChange,
}) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
    <Typography variant="subtitle2" color="text.secondary">
      Rate {colleagueFirstName}
    </Typography>
    {RATING_CATEGORIES.map((cat) => (
      <Box
        key={cat.key}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1,
        }}
      >
        <Typography variant="body2" sx={{ minWidth: 110 }}>
          {cat.label}
        </Typography>
        <Rating
          size="small"
          value={ratings[cat.key] ?? 0}
          onChange={(_, val) => onRatingChange(cat.key, val)}
        />
      </Box>
    ))}
  </Box>
);
